import { render, staticRenderFns } from "./BFormImage.vue?vue&type=template&id=31774776&scoped=true"
import script from "./BFormImage.vue?vue&type=script&lang=js"
export * from "./BFormImage.vue?vue&type=script&lang=js"
import style0 from "./BFormImage.vue?vue&type=style&index=0&id=31774776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31774776",
  null
  
)

export default component.exports